"use client"

import { cn } from "@/lib/utils"
import { TopicTag } from "@/types/blog"

interface TopicFilterProps {
  tags: TopicTag[]
  selectedTopic: string | null
  onSelectTopic: (topic: string | null) => void
  className?: string
}

export function TopicFilter({
  tags,
  selectedTopic,
  onSelectTopic,
  className
}: TopicFilterProps) {
  return (
    <div
      className={cn(
        "overflow-x-auto pb-2 touch-pan-x scrollbar-hide md:scrollbar-thin",
        className
      )}
    >
      <div className="flex flex-wrap gap-2">
        {/* All Button */}
        <button
          onClick={() => onSelectTopic(null)}
          className={cn(
            "px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium transition-all duration-200 whitespace-nowrap",
            selectedTopic === null
              ? "bg-primary text-white shadow-sm"
              : "bg-white border border-border text-text-secondary hover:border-primary hover:text-primary"
          )}
          aria-pressed={selectedTopic === null}
          aria-label="Show all posts"
        >
          All
        </button>

        {/* Topic Buttons */}
        {tags.map((tag) => (
          <button
            key={tag.slug}
            onClick={() => onSelectTopic(tag.slug)}
            className={cn(
              "px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium transition-all duration-200 whitespace-nowrap",
              selectedTopic === tag.slug
                ? "bg-primary text-white shadow-sm"
                : "bg-white border border-border text-text-secondary hover:border-primary hover:text-primary"
            )}
            aria-pressed={selectedTopic === tag.slug}
            aria-label={`Filter by ${tag.name}`}
          >
            {tag.name}
            <span className="ml-1 sm:ml-1.5 text-[10px] sm:text-xs opacity-70">({tag.count})</span>
          </button>
        ))}
      </div>
    </div>
  )
}
